import { PUBLIC_URL } from '../constants/app';

export const redirectToPublicProfile = ({
  publicToken,
  state,
}: {
  publicToken: string;
  state: Record<string, string>;
}) => {
  const redirectUrl = new URL('/profile', PUBLIC_URL);
  redirectUrl.searchParams.set('token', publicToken);
  redirectUrl.searchParams.set('state', JSON.stringify(state));
  window.location.assign(redirectUrl.toString());
};
